import { render, staticRenderFns } from "./lock_tooltip.vue?vue&type=template&id=a123a53a"
import script from "./lock_tooltip.vue?vue&type=script&lang=js"
export * from "./lock_tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports